var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-line"},[(_vm.isQuoted)?_c('comment-quote',{attrs:{"line":_vm.line,"quoteRegex":_vm.quoteRegex}}):_c('span',[_c('CommentLineWithMention',{attrs:{"message":_vm.line}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }